import { ProjectActionType } from '../../context/project/actions';
import { useProjectContext } from '../../context/project/context';

type UseSetSelectedClientsResponse = {
  setSelectedStops: (selectedStops: Array<string>) => void;
  selectedStops: Array<string>;
  selectStopFromMap: ({ stopId, withControlKey }: { stopId: string; withControlKey?: boolean }) => void;
};

// Hooks act as 'Adapter' layer.
export const useSetSelectedProjectStops = (): UseSetSelectedClientsResponse => {
  const { projectState, projectDispatch } = useProjectContext();

  const setSelectedStops = (selectedStops: Array<string>) => {
    projectDispatch({
      type: ProjectActionType.SET_SELECTED_STOPS,
      payload: {
        selectedStops,
      },
    });
  };

  const selectStopFromMap = ({ stopId, withControlKey }: { stopId: string; withControlKey?: boolean }) => {
    projectDispatch({
      type: ProjectActionType.ON_SELECT_STOP,
      payload: {
        stopId,
        withControlKey,
      },
    });
  };

  return {
    setSelectedStops,
    selectedStops: projectState.stops.selectedStops,
    selectStopFromMap,
  };
};
